import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';
import {
    OFFER_CARD_PRICE_COMPOSITION_MONTHLY_HEADLINE,
    OFFER_CARD_PRICE_COMPOSITION_ONETIME_HEADLINE,
} from 'Container/OfferDisplay/constant';
import {createHeadline, IHeadlineProperties} from '@vfde-brix/headline';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const renderHeadlinesMonthly = (element: HTMLElement) => {

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_COMPOSITION_MONTHLY_HEADLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h2',
        stdContent: 'Preis pro Monat',
        spacing: '100',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    createHeadline(accordionContentDIV, headlineProperties);
};

const renderHeadlinesOnetime = (element: HTMLElement) => {

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_COMPOSITION_ONETIME_HEADLINE)[0];
    const headlineProperties: IHeadlineProperties = {
        optTag: 'h2',
        stdContent: 'Einmal-Preis',
        spacing: '100',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    createHeadline(accordionContentDIV, headlineProperties);

};

/**
 * renders the multi divider dynamically
 * @param element
 */
export const renderPriceDetailHeadlines = (element: HTMLElement) => {

    // Creates Brix Component Accordion and returns DIV for Item
    renderHeadlinesMonthly(element);
    renderHeadlinesOnetime(element);

};
